<template>
	<!-- 企业隐患排查计划 -->
	<section>
		<!--工具条-->
		<el-col  :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item v-if="bquery">
					<el-input v-model="filters.companyName" placeholder="企业名称"></el-input>
				</el-form-item>
				<el-form-item >
					<el-input v-model="filters.planName" placeholder="排查计划名称"></el-input>
				</el-form-item>
				<el-form-item >
					<el-button type="primary" v-on:click="getPageList">查询</el-button>
				</el-form-item>
				<el-form-item v-if="bshow">
					<el-button type="primary" v-on:click="showAddyhpcPlan">制定隐患排查计划</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="pagelist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			<el-table-column prop="coName" label="企业名称" min-width="200" align="center">
			</el-table-column>
			<el-table-column prop="planName" label="排查计划名称" align="center" min-width="200">
			</el-table-column>
			<el-table-column prop="selfCheckPropertyName" label="排查性质" min-width="100" align="center">
			</el-table-column>
			<el-table-column prop="selfCheckContent" label="排查内容" align="center"  min-width="300">
			</el-table-column>
			<el-table-column prop="riskLevelName" label="风险级别" align="center" min-width="150">
			</el-table-column>
      		<el-table-column prop="workerName" label="排查人" align="center" min-width="150">
			</el-table-column>
			<el-table-column prop="selfCheckPlanDate" label="计划排查日期" align="center" min-width="120">
			</el-table-column>
			<el-table-column prop="createTime" label="创建日期" align="center" min-width="200">
			</el-table-column>
			<el-table-column  v-if="bshow" label="操作" align="center" width="100">
				<template slot-scope="scope">
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<el-dialog title="制定隐患排查计划" v-model="addyhpcFormVisible" :close-on-click-modal="false" >
			<el-form :label-position="labelPosition" :model="addyhpcForm" label-width="120px" :rules="addyhpcFormRules" ref="addyhpcForm">
				<el-row>					   
					<el-form-item label="排查计划名称" prop="planName">
						<el-input v-model="addyhpcForm.planName" auto-complete="off"></el-input>
					</el-form-item>
			    </el-row>
				<el-row>					   
					<el-form-item label="排查内容" prop="selfCheckContent">
						<el-input v-model="addyhpcForm.selfCheckContent" auto-complete="off"></el-input>
					</el-form-item>
			    </el-row>
				<el-row>
					<el-col :span="11"> 
						<el-form-item label="排查性质" >
							<el-select v-model="selfCheckPropertyvalue" placeholder="请选择" >
								<el-option v-for="item in selfCheckPropertyoptions" :key="item.Mpid" :label="item.MpCn" :value="item.MpValue"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="11" >      
						<el-form-item label="风险级别" >
							<el-select v-model="riskLevelvalue" placeholder="请选择" >
								<el-option v-for="item in riskLeveloptions" :key="item.Mpid" :label="item.MpCn" :value="item.MpValue"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
			    </el-row>
				<el-row>
				<el-col :span="11"> 
					<el-form-item label="计划排查日期" prop="selfCheckPlanDate">
						<el-date-picker v-model="addyhpcForm.selSelfCheckPlanDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="11" >      
					<el-form-item label="排查人员" >
						<el-select v-model="workerId" placeholder="请选择" >
							<el-option v-for="item in companymemberlist" :key="item.Mpid" :label="item.name+'('+item.workerTypeName+')'" :value="item.workerId"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			    </el-row>		

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addyhpcFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="handleAddyhpczl">提交</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import { selfCheckPlanList,addSelfCheckPlan,getparamsByType,allWorkerList,deleteSelfCheckPlan} from '../../api/api';
	export default {		
		data() {
			return {
				objectId:0, //当前登录的用户id，新增会用到
				coId:0, //当前登录的用户企业id

				bquery:false,//管理员权限
				bshow:false,//是否显示操作按钮

				filters: {
					companyName: '',
					planName:''
				},
				pagelist: [],
				total: 0,
				page: 1,
				listLoading: false,

				//字典表
				selfCheckPropertyoptions: [],
				selfCheckPropertyvalue:'',

				riskLeveloptions: [],
				riskLevelvalue:'',

				companymemberlist: [],
				workerId:0,

				//新增
				addyhpcFormVisible: false, 
				addyhpcFormRules: {
					planName: [{ required: true, message: "请输入隐患排查计划名称", trigger: "blur" }],
					selfCheckPlanDate: [{ required: true, message: "请选择计划排查日期", trigger: "blur" }],
					selfCheckContent: [{ required: true, message: "请输入检查内容", trigger: "blur" }],					
				},
				
				addyhpcForm: {
					createUserId:0,
					coId:0,
					workerId:0,

					planName:"",
					selfCheckContent:"",
					selfCheckProperty:"",
					riskLevel:"",

					selfCheckPlanDate:"",     
					selSelfCheckPlanDate:null,
				},
				labelPosition: 'right',

			}
		},
		methods: {
			handleCurrentChange(val) {				
				this.page = val;
				this.getPageList();
			},
			//获取分页列表
			getPageList() {
				let para = {
					page: this.page,
					pageSize:20,
					objectId:this.objectId,
					planName:this.filters.planName,
					coName: this.filters.companyName,
				};

				this.listLoading = true;

				selfCheckPlanList(para).then((res) => {

					if(res.data.code==0){
						this.total = res.data.data.total;
						this.pagelist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			
			getQYPCXZdic() {
				let para={
					MpType:"QYPCXZ",
					MpParentId:"51"
				}
				getparamsByType(para).then((res) => {
					if(res.data.code==0){
						this.selfCheckPropertyoptions  =res.data.data
						this.selfCheckPropertyvalue=this.selfCheckPropertyoptions[0].MpValue
					}
				});
			},

			getFXJBdic() {
				let para={
					MpType:"FXJB",
					MpParentId:"9"
				}
				getparamsByType(para).then((res) => {
					if(res.data.code==0){
						this.riskLeveloptions  =res.data.data
						this.riskLevelvalue=this.riskLeveloptions[0].MpValue
					}
				});
			},
			showAddyhpcPlan: function (index, row) {

				this.addyhpcForm={
					createUserId:this.objectId,
					coId: this.coId,
					workerId:0,

					planName:"",
					selfCheckContent:"",
					selfCheckProperty:"",
					riskLevel:"",

					selfCheckPlanDate:"",     
					selSelfCheckPlanDate:null,
				},

				this.addyhpcFormVisible=true
				//没有人员的时候，不显示备选
				if (this.workerId==0) {
					this.workerId=''
				} 	
			
			},
			handleAddyhpczl: function () {
				if(this.workerId=='')
				{
					this.$message.error("请选择排查人员");
				}
				else{
					if(this.addyhpcForm.selSelfCheckPlanDate!=null){
						this.addyhpcForm.selfCheckPlanDate = this.addyhpcForm.selSelfCheckPlanDate.toLocaleString();
					}
				
					this.addyhpcForm.selfCheckProperty= this.selfCheckPropertyvalue
					this.addyhpcForm.riskLevel= this.riskLevelvalue
					this.addyhpcForm.workerId= this.workerId
				
					this.$refs.addyhpcForm.validate((valid) => {
						if (valid) {
							this.$confirm('确认添加排查计划吗？', '提示', {}).then(() => {						
								addSelfCheckPlan(this.addyhpcForm).then((res) => {
										if(res.data.code==0){
											this.addyhpcFormVisible = false;
											this.$message.success(res.data.message);
											this.getPageList()
										}
										else{
											this.$message.error(res.data.message);
										}
								});
							});	
						}
					});
				}
			},	
			//获取企业全部人员列表
			getAllWorkerList() {
				let para = {
					coId:this.coId,
				};

				allWorkerList(para).then((res) => {
					if(res.data.code==0){
						this.companymemberlist = res.data.data;
						this.workerId=this.companymemberlist[0].workerId
					}
				});
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除这个计划吗？', '提示', {}).then(() => {
					let para = {
						planId: row.planId
					};
					deleteSelfCheckPlan(para).then((res) => {
						if(res.data.code==0){
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							
							this.getPageList();
						}
						else{
							this.$message.error(res.data.message);
						}

					});
				});

			},
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.objectId = user.data.userId
			this.coId = user.data.coId

			if (user.data.roleId=="4") {
				this.filters.companyName = user.data.userName	
				this.bshow=true
				this.bquery=false
				this.getAllWorkerList();
			} else {
				this.bquery=true
				this.bshow=false
			}

			this.getPageList();
			this.getQYPCXZdic();
			this.getFXJBdic();
			
		}
	}

</script>

<style scoped>
	
	
</style>


// WEBPACK FOOTER //
// selfcheckPlan.vue?27ba8ebc